// extracted by mini-css-extract-plugin
module.exports = {"container":"empty-community_container__3S8l7","primaryText":"empty-community_primaryText__3UcvL","secondaryText":"empty-community_secondaryText__1TB5c"};